import Survicate from '@survicate/survicate-web-package/survicate_widget'

import i18n from './i18n'
import { onConsentChange, hasConsent } from './onetrust'

interface SurvicateUserTraits {
  user_id: string
  email: string
  created_at: string | Date
  solicitor: boolean

  mandatory_visma_reporting_user_works_in_accounting_office: boolean
  mandatory_visma_reporting_user_is_professional_user: boolean
  user_country: string
}

onConsentChange('analytics', {
  onAccepted: onConsentGranted,
  onDenied: stopSurvicate,
})

/**
 * Identify user for Survicate surveys.
 * Call this after user authentication with user details.
 * Survey will only run if analytics consent has been granted.
 */
export function identifySurvicateUser(
  user: Omit<
    SurvicateUserTraits,
    | 'mandatory_visma_reporting_user_works_in_accounting_office'
    | 'mandatory_visma_reporting_user_is_professional_user'
    | 'user_country'
  >
): void {
  if (!hasConsent('analytics')) return

  Survicate.setVisitorTraits({
    ...user,
    mandatory_visma_reporting_user_works_in_accounting_office: false,
    mandatory_visma_reporting_user_is_professional_user: false,
    user_country: 'SE',
  })
  Survicate.retarget()
}

/**
 * Clear cached user (e.g., on logout).
 */
export function clearSurvicateUser(): void {
  void Survicate.destroyVisitor()
}

export function setSurvicateLocale(locale: string) {
  if (!hasConsent('analytics')) return

  Survicate.setSurveyLanguage(locale)
}

// --- Internal helpers ---

function onConsentGranted(): void {
  void Survicate.init({
    workspaceKey: import.meta.env.VITE_SURVICATE_WORKSPACE_KEY ?? '',
  }).then(() => {
    Survicate.addEventListener(Survicate.ApiEvent.surveyDisplayed, () => {
      setSurvicateLocale(i18n.global.locale.value)
    })
  })
}

function stopSurvicate(): void {
  void Survicate.destroyVisitor()
  if ('_sva' in window) delete window._sva
  if ('_svc' in window) delete window._svc
  if ('_svd' in window) delete window._svd
  if ('_svx' in window) delete window._svx
}
